/**
 * The Klöver mark: a four-leaf clover — "klöver" is Swedish slang for money,
 * and the clover stands for luck and growth. Drawn with currentColor so it
 * follows the text color it sits next to (usually text-primary).
 */
export function Logo({ className = "h-6 w-6" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <g fill="currentColor">
        <circle cx="45" cy="45" r="25" />
        <circle cx="83" cy="45" r="25" />
        <circle cx="45" cy="83" r="25" />
        <circle cx="83" cy="83" r="25" />
      </g>
      <path
        d="M96 96 Q 108 108 110 121"
        stroke="currentColor"
        strokeWidth="9"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Wordmark({ className = "" }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <Logo className="h-6 w-6 text-primary" />
      <span className="text-lg font-semibold tracking-tight">Klöver</span>
    </span>
  );
}
